import React from 'react';
import '../icon.scss';
import './hamburger.scss';

export default function Hamburger({ custom = "", isOpen = false }) {
  return (
    <span className={`icon icon--hamburger ${custom === "header_dropdown" ? `icon--hamburger--${custom}` : ''} ${isOpen ? 'icon--hamburger--open' : ''}`}>
      <span />
    </span>
  );
}
